export default {
  GET_SEARCH_SIFT: '  GET_SEARCH_SIFT',
  GET_SEARCH_COURSE_LIST: 'GET_SEARCH_COURSE_LIST',
  SET_SEARCH_SIFT: 'SET_SEARCH_SIFT',
  SET_SEARCH_CHOOSE_SIFT: 'SET_SEARCH_CHOOSE_SIFT',
  SET_SEARCH_NAME: 'SET_SEARCH_NAME',
  SET_SEARCH_NAME_SORT: 'SET_SEARCH_NAME_SORT',
  SET_SEARCH_COURSE_SORT: 'SET_SEARCH_COURSE_SORT',
  SET_SEARCH_COURSE_LIST: 'SET_SEARCH_COURSE_LIST',
  SET_HIT_TEACHER: 'SET_HIT_TEACHER',
  SET_NOCOURSEREC_WORD: 'SET_NOCOURSEREC_WORD',
  SET_NOCOURSEREC_COURSE: 'SET_NOCOURSEREC_COURSE',
  SET_PAGENATION_COUNT: 'SET_PAGENATION_COUNT',
  ADD_SEARCH_COURSE_LIST: 'ADD_SEARCH_COURSE_LIST',
  UPDATA_COURSE_LIST: 'UPDATA_SEARCH_COURSE_LIST',
  SET_COURSE_COUNT: 'SET_SEARCH_COURSE_COUNT',
  SET_DATA_EXP_TAG: 'SET_DATA_EXP_TAG'
}



// WEBPACK FOOTER //
// ./src/views/SearchPage/store/types.js